<template>
    <header class="sidebar   d-lg-block ldt-fade-in "  id="sidebar" @click="closeSidebar" v-if="isSidebarOpen">
        <div class="photo">
            <img alt="emil" class="image" src="../../assets/me2.png">
            <h4 class="text">{{fullName}}</h4>
        </div>
        <div class="content">
            <section class="bio">
                <div>
                    <span><font-awesome-icon icon="briefcase" /></span>
                    <strong>Front-end Developer</strong>
                </div>
                <div>
                    <span><font-awesome-icon icon="birthday-cake" /></span>
                    <strong>19.05.1991</strong>
                </div>
                <div>
                    <span><font-awesome-icon icon="envelope" /></span>
                    <strong>luchianemil@gmail.com</strong>
                </div>
                <div>
                    <span><font-awesome-icon icon="phone" /></span>
                    <strong>+40741125806</strong>
                </div>
                <div>
                    <span><font-awesome-icon icon="city" /></span>
                    <strong>Bucharest</strong>
                </div>
            </section>
            <section class="links">
                <strong>Public Profiles:</strong>
                <a href="https://github.com/EmilLM" target="_blank">
                    <font-awesome-icon v-bind:icon="['fab','git-square']" />
                </a>
                <a href="https://emilsprojects.site" target="_blank">
                    <font-awesome-icon v-bind:icon="['fab','linkedin']" />
                </a>
                <a href="https://facebook.com" target="_blank">
                    <font-awesome-icon v-bind:icon="['fab','facebook-square']" />
                </a>
            </section>
        </div>
    </header>
</template>


<script>
    import { store, mutations } from '../../store.js'

    export default {
        name: "Sidebar",
        props: {
            fullName: String
        },
        methods: {
            closeSidebar: mutations.toggleBar
        },
        computed: {
            isSidebarOpen() {
                return store.isSidebarShowing
            }
        }
    }
</script>

<style scoped>
    .photo {
        position: relative;
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .image {
        opacity: 1;
        display: block;
        width: 60% !important;
        height: auto;
        transition: .5s ease;
        margin: 0 auto;
        padding-top: 40px;
    }

    .text {
        padding-top: 20px;
        color: white;
        font-weight: 700;
        text-align: center;
        text-shadow: 0 0 5px blue;
    }
/*check _sidebar.scss*/
</style>
